import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];
import React, { forwardRef } from 'react';
import { TimeSeparatorIcon } from '@deliveryhero/armor-icons';
import { useDatePickerTimeSelectorClassNames } from './hooks/useDatePickerTimeSelectorClassNames';
import { useDatePickerTimeSelector } from './hooks/useDatePickerTimeSelector';
import { DatePickerTimeSelectorRoot, DatePickerTimeSelectorClock, DatePickerTimeSelectorInput, DatePickerTimeSelectorDayPeriodSelector, DatePickerTimeSelectorButton } from './style';
import { DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../../utils/hooks';
export var DatePickerTimeSelector = forwardRef(function DatePickerTimeSelector(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX);
  var classNameComponents = useDatePickerTimeSelectorClassNames(DATE_PICKER_TIME_SELECTOR_CLASS_PREFIX, className);

  var _useDatePickerTimeSel = useDatePickerTimeSelector(props, ref),
      rootProps = _useDatePickerTimeSel.rootProps,
      hourInputProps = _useDatePickerTimeSel.hourInputProps,
      minuteInputProps = _useDatePickerTimeSel.minuteInputProps,
      buttonAMProps = _useDatePickerTimeSel.buttonAMProps,
      buttonPMProps = _useDatePickerTimeSel.buttonPMProps;

  return React.createElement(DatePickerTimeSelectorRoot, Object.assign({}, rootProps, {
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(DatePickerTimeSelectorClock, {
    theme: theme
  }, React.createElement(DatePickerTimeSelectorInput, Object.assign({}, hourInputProps, {
    className: classNameComponents.Input
  })), ' ', React.createElement(TimeSeparatorIcon, {
    className: classNameComponents.TimeSeparatorIcon
  }), ' ', React.createElement(DatePickerTimeSelectorInput, Object.assign({}, minuteInputProps, {
    className: classNameComponents.Input
  }))), React.createElement(DatePickerTimeSelectorDayPeriodSelector, null, React.createElement(DatePickerTimeSelectorButton, Object.assign({}, buttonAMProps, {
    theme: theme,
    className: classNameComponents.Button
  }), "AM"), React.createElement(DatePickerTimeSelectorButton, Object.assign({}, buttonPMProps, {
    theme: theme,
    className: classNameComponents.Button
  }), "PM")));
});
DatePickerTimeSelector.defaultProps = {};